<template>
<div v-if="surgeryId && surgeryId > 0">
    <div :style="{
    width: svgScale * SVGImgSize.ImgW + 'px',
    }"
    style="margin:0px auto">
        <span :style="surgeryInfo&&surgeryInfo.enum_asa>=3? 'color:red':''">&nbsp;&nbsp;&nbsp;&nbsp;手术等级:{{surgeryInfo&&surgeryInfo.surgery_scale}}</span>
    </div>
 <div
    ref="svgBoxRef"
    :style="{
    width: svgScale * SVGImgSize.ImgW + 'px',
    }"
    style="margin:0px auto"
    v-if="imgType"
  >
  <!-- {{imgType}} -->
    <svg
      :width="SVGImgSize.ImgW"
      :height="SVGImgSize.ImgH"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      :transform="`translate(${svgTranslateX},${svgTranslateY}) scale(${svgScale})`"
    >
      <image
        :key="'person'"
        :x="0"
        :y="0"
        :width="SVGImgSize.ImgW"
        :height="SVGImgSize.ImgH"
        :href="imgType"
        style="pointer-events: none"
      />
    </svg>
  </div>
</div>

</template>

<script>
import man from '../../assets/HumanPic/man.png'
import man1 from '../../assets/HumanPic/man1.png'
import man2 from '../../assets/HumanPic/man2.png'
import man3 from '../../assets/HumanPic/man3.png'
import man4 from '../../assets/HumanPic/man4.png'
import woman from '../../assets/HumanPic/woman.png'
import woman1 from '../../assets/HumanPic/woman1.png'
import woman2 from '../../assets/HumanPic/woman2.png'
import woman3 from '../../assets/HumanPic/woman3.png'
import woman4 from '../../assets/HumanPic/woman4.png'
import { mapGetters } from 'vuex'
const SVGImgSize = {
    ImgW: 800,
    ImgH: 600
}
const SVGCircleSize = {
    Width: 10
}
const SVGRectSize = {
    Width: 200,
    Height: 40
}
const HandleType = {
    REVOKE: `REVOKE`,
    OUT: `OUT`
}
export default {
    name: `humanBodyDiagramJKZT`,
    props: {
    // 是否封存
        hisArchive: {
            type: Boolean,
            default: false
        },
        status: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            surgeryId: this.$route.query.surgery_id,
            recordType: this.$route.query.record_type,
            token: this.$route.query.token,
            showedit: false,
            choosecircle: ``,
            addfromtitle: `添加`,
            surgeryInfo: undefined,
            mdata: {
                record_templates: [{ is_empty: true, occur_time: this.$moment().format(`YYYY/MM/DD`) }]
            },
            msg: `closeWindow`,
            svgScale: 1,
            svgTranslateX: 0,
            svgTranslateY: 0,
            disX: 0,
            disY: 0,
            tubesPageHeight: 600,
            pTubesList: [

            ],
            tubesRecord: null,
            moveType: ``,
            moveing: false,
            hasMove: false,
            SVGImgSize,
            SVGCircleSize,
            SVGRectSize,
            HandleType,
            man,
            man1,
            man2,
            man3,
            man4,
            woman,
            woman1,
            woman2,
            woman3,
            woman4
        }
    },
    watch: {
        tubesPageHeight: {
            handler() {
                this.calcSvgScale()
            },
            immediate: true
        }
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `sys_enums`, `drug/drug_type`, `drug/drug_unit`, `drug/drug_way`, `screenHeight`]),
        imgType() {
            if (this.surgeryInfo && this.surgeryInfo.visit_info && this.surgeryInfo.visit_info.enum_sex == 1) {
                if (this.surgeryInfo.enum_surgery_scale == 1) {
                    return this.man1
                } else if (this.surgeryInfo.enum_surgery_scale == 2) {
                    return this.man2
                } else if (this.surgeryInfo.enum_surgery_scale == 3) {
                    return this.man3
                } else if (this.surgeryInfo.enum_surgery_scale == 4) {
                    return this.man4
                }
                return this.man
            } else if (this.surgeryInfo && this.surgeryInfo.visit_info) {
                if (this.surgeryInfo.enum_surgery_scale == 1) {
                    return this.woman1
                } else if (this.surgeryInfo.enum_surgery_scale == 2) {
                    return this.woman2
                } else if (this.surgeryInfo.enum_surgery_scale == 3) {
                    return this.woman3
                } else if (this.surgeryInfo.enum_surgery_scale == 4) {
                    return this.woman4
                }
                return this.woman
            }
        }

    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        this.loadSurgery()
        this.loadPermissions()
        this.$store.dispatch(`ADD_WARD_AUTH`)
        this.$store.dispatch(`ADD_CURRENTUSER`)
        // this.loadInfusionChannel()
    },
    methods: {
        loadSurgery() {
            if (!this.surgeryId) return
            let req = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
            req.then(data => {
                this.surgeryInfo = data
                console.log(`surgeryInfo`, this.surgeryInfo)
            }).catch(e => console.log(e))
        },

        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {
                console.log(e)
            })
        },

        ExtraButtonClick(target) {
            this[target.emit] && this[target.emit](target)
        },

        getCircleFillColor(record) {
            return `#2196F3`
        },

        getLineFillColor(record) {
            return this.getCircleFillColor(record)
        },

        getTextFillColor(record) {
            if (this.status) return `#000`
            return `#000`
        },

        setTubesRecord(record) {
            this.tubesRecord = { ...record }
        },
        calcSvgScale() {
            const svgBoxHeight = this.tubesPageHeight

            if (svgBoxHeight < 0) return

            const svgScale = svgBoxHeight ? svgBoxHeight / this.SVGImgSize.ImgH : 1
            const svgTranslateY = svgBoxHeight ? (svgBoxHeight - this.SVGImgSize.ImgH) / 2 : 0
            const svgTranslateX = svgBoxHeight
                ? (svgScale * this.SVGImgSize.ImgW - this.SVGImgSize.ImgW) / 2
                : 0

            this.svgScale = svgScale

            this.svgTranslateX = svgTranslateX
            this.svgTranslateY = svgTranslateY
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Anesthsia/humanBodyDiagramJKZT.vue